import React from 'react';
import couvert from '../svg/svg-couvert.svg';
import svgcook from '../svg/svg-cook.svg';
import { useTranslation } from 'react-i18next';

function Navbar() {
    const{t, i18n} = useTranslation();
    return (        
    <header id="header" className="fixed-top">
        <nav className=" navbar navbar-expand-lg navbar-dark nav-menu">
            <div className="container d-flex ">
                <div className="logo me-auto ">
                    <a href="#hero">Old Tbilisi</a>
                </div>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav ms-auto">
                        {/* Navigation */}
                        <li className="nav-item active">
                            <a className="nav-link" href="#hero"><span data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"> Home</span></a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#about"><span data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"> {t("about")}</span></a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#menu"><span data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"> Menu <img src={couvert} className="i-couvert" alt="Book a table at Old Tbilisi restaurant"></img></span></a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#specials"><span data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"> {t("specialities")}</span></a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#testimonials"><span data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"> {t("testimonials")}</span></a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#chefs"><span data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"> Chef <img className='i-cook-nav' src={svgcook} alt="Chef Old Tbilisi"/></span></a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#events"><span data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"> {t("events")}</span></a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#contact"><span data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"> Contact</span></a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#gallery"><span data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"> {t("gallery")} <i className="no-pointer far fa-images"></i></span></a>
                        </li>
                        <li className="book-a-table"><a href="#book-a-table">{t("book-a-table")} </a></li>
                    </ul>
                </div>
            </div>
        </nav>
    </header>

    )
}

export default Navbar;
